import {
  DELETE_DOCTOR,
  DELETE_DOCTOR_SUCCESS,
  DELETE_DOCTOR_FAILURE,
} from 'store/deleteDoctor/deleteDoctorAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const deleteDoctorReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_DOCTOR:
      return { ...state, loading: true };
    case DELETE_DOCTOR_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DELETE_DOCTOR_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteDoctorReducer;
